import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api, { windowLabel } from "@/lib/api";
import { toast } from "sonner";
import { Star } from "lucide-react";

export default function NewReviewPage() {
  const [orders, setOrders] = useState([]);
  const [orderId, setOrderId] = useState("");
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/orders/my").then((r) => {
      const eligible = r.data.filter((o) => o.status === "picked_up" && !o.review_id);
      setOrders(eligible);
      if (eligible[0]) setOrderId(eligible[0].id);
    });
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!orderId) return toast.error("Pick a completed pickup to review.");
    setSubmitting(true);
    try {
      await api.post("/reviews", { order_id: orderId, rating, comment });
      toast.success("Thanks — review submitted! +50 pts");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not submit");
    }
    setSubmitting(false);
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-8">
      <h1 className="font-fredoka text-3xl font-bold mb-2" data-testid="new-review-title">How was your pickup? ⭐</h1>
      <p className="text-slate-600 mb-4 text-sm">Reviews go live after a quick admin check.</p>
      {orders.length === 0 ? (
        <div className="card-clay p-6 text-center">
          <p className="text-slate-500">No completed pickups to review yet.</p>
          <Link to="/dashboard" className="btn-push-outline inline-block mt-3 px-5 py-2.5">Back to dashboard</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="card-clay p-6 space-y-4" data-testid="review-form">
          <label className="block">
            <div className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-1">Pickup</div>
            <select className="input-clay h-11 px-3 w-full" value={orderId} onChange={(e) => setOrderId(e.target.value)} data-testid="review-order">
              {orders.map((o) => <option key={o.id} value={o.id}>{windowLabel(o.window)} · {o.pickup_date} · {o.community}</option>)}
            </select>
          </label>
          <div>
            <div className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-1">Rating</div>
            <div className="flex gap-1">
              {[1,2,3,4,5].map((n) => (
                <button type="button" key={n} onClick={() => setRating(n)} className="p-1" data-testid={`star-${n}`}>
                  <Star size={32} className={n <= rating ? "fill-amber-400 text-amber-400" : "text-slate-300"}/>
                </button>
              ))}
            </div>
          </div>
          <label className="block">
            <div className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-1">Comment (optional)</div>
            <textarea rows={4} maxLength={500} className="input-clay px-3 py-2 w-full" value={comment} onChange={(e) => setComment(e.target.value)} data-testid="review-comment"/>
          </label>
          <button disabled={submitting} className="btn-push-green w-full py-3" data-testid="review-submit">{submitting ? "Sending…" : "Submit review"}</button>
        </form>
      )}
    </div>
  );
}
